import { render, staticRenderFns } from "./CompanyEnableTwoFaAction.vue?vue&type=template&id=2316fd06&"
import script from "./CompanyEnableTwoFaAction.vue?vue&type=script&lang=js&"
export * from "./CompanyEnableTwoFaAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports